import {
  ICreateQueryProps,
  // ISAdminClientState,
  IShopifyQueryItem,
  IShopifyTemplateItem,
  IUpdateQueryProps,
  MapFieldCleanBodyProps,
  MapFieldDateBodyProps,
  MapFieldDeleteBodyProps,
  MapFieldLoopBodyProps,
  MapFieldPatternBodyProps,
  MapFieldReplaceKeyOrValueBodyProps,
  MapFieldSearchBodyProps,
  MapFieldSubstringBodyProps,
  IupdateMapFieldBodyProps,
  IgetTenantsBody,
} from 'interfaces/superAdmin.interface';
import * as SuperAdminTypes from './superAdmin.types';
import {
  createMapFieldAPI,
  createMapFieldTemplateAPI,
  createShopifyQueryAPI,
  createShopifyTemplateAPI,
  deleteMapFieldAPI,
  deleteMapFieldTemplateAPI,
  deleteShopifyQueryAPI,
  deleteShopifyTemplateAPI,
  getClientsAPI,
  getMapFieldsAPI,
  getMapFieldsTemplatesAPI,
  getShopifyQueriesAPI,
  getTemplatesAPI,
  getTenantsAPI,
  updateMapFieldAPI,
  updateShopifyQueryAPI,
} from 'api/endpoints/superAdmin/superAdmin.api';
import { ITenantUser } from 'interfaces/tenantUsers.interface';
import moment from 'moment';
import { TgetConnectorsAPIBodyProps } from 'api/endpoints/meta/meta.response.interface';
import { getConnectionsAPI } from 'api/endpoints/meta/meta.api';
import {
  messageError,
  messageSuccess,
  messageWarning,
} from 'views/components/UI/message';
import { notificationErr } from 'views/components/UI/notification';
import { superAdminError } from 'utils/errorCodes';
import { ITranslate } from 'interfaces/general.interface';
import {
  ISAdminTenantState,
  ISAdminUserTenantState,
} from 'api/endpoints/superAdmin/superAdmin.response.interface';

export async function getClientsAction({
  dispatch,
  tenantsBody,
  token,
  translate,
}: {
  dispatch: React.Dispatch<any>;
  tenantsBody: IgetTenantsBody;
  token: string;
  translate: ITranslate;
}) {
  dispatch({ type: SuperAdminTypes.SET_IS_LOADING, payload: true });
  try {
    const [getClientsFetch, getTenantsFetch] = await Promise.all([
      getClientsAPI({ token, index: 0, limit: 10000 }),
      getTenantsAPI({ body: tenantsBody, token }),
    ]);
    if (
      getClientsFetch.response.status === 200 &&
      getTenantsFetch.response.status === 200
    ) {
      getClientsFetch.data.forEach((item, index) => {
        getClientsFetch.data[index].logo = item.logo
          ? `${item.logo}?ts=${moment().unix()}`
          : '';
      });
      dispatch({
        type: SuperAdminTypes.SET_CLIENTS,
        payload: {
          wholesale: getClientsFetch.data,
          brand: getTenantsFetch.data,
        },
      });
    }
  } catch (error) {
    console.log(error);
  } finally {
    dispatch({ type: SuperAdminTypes.SET_IS_LOADING, payload: false });
  }
}

export async function getMoreTenantsAction({
  dispatch,
  tenantsBody,
  signal,
  translate,
  token,
}: {
  dispatch: React.Dispatch<any>;
  tenantsBody: IgetTenantsBody;
  signal: AbortSignal | undefined;
  translate: ITranslate;
  token: string;
}): Promise<boolean> {
  dispatch({ type: SuperAdminTypes.SET_IS_LOADING_MORE_TENANTS, payload: true });
  const copyOfTenantsBody: IgetTenantsBody = JSON.parse(JSON.stringify(tenantsBody));
  if (copyOfTenantsBody.index === 0) {
    copyOfTenantsBody.index = 40;
  } else {
    copyOfTenantsBody.index = copyOfTenantsBody.index + 40;
  }

  try {
    const getTenantsFetch = await getTenantsAPI({
      body: copyOfTenantsBody,
      token,
      signal,
    });
    if (getTenantsFetch.data.length === 0 || getTenantsFetch.data.length < 40) {
      dispatch({ type: SuperAdminTypes.SET_THERE_ARE_MORE_TENANTS, payload: false });
      return false;
    } else {
      dispatch({ type: SuperAdminTypes.SET_THERE_ARE_MORE_TENANTS, payload: true });
    }

    if (getTenantsFetch.response.status === 200 && getTenantsFetch.data.length > 0) {
      dispatch({
        type: SuperAdminTypes.ADD_MORE_TENANTS,
        payload: {
          tenants: getTenantsFetch.data,
          body: copyOfTenantsBody,
        },
      });
      return true;
    }
    return false;
  } catch (err) {
    // return notificationErr(catalogError.add_more_products_to_catalog_001, translate)
    return false;
  } finally {
    dispatch({ type: SuperAdminTypes.SET_IS_LOADING_MORE_TENANTS, payload: false });
  }
}

export async function getTenantsWithUsersAction({
  dispatch,
  tenantsBody,
  querySearch,
  signal,
  token,
  translate,
}: {
  dispatch: React.Dispatch<any>;
  tenantsBody: IgetTenantsBody;
  querySearch: string;
  signal: AbortSignal | undefined;
  token: string;
  translate: ITranslate;
}) {
  dispatch({
    type: SuperAdminTypes.SET_IS_LOADING_GET_TENANTS_WITH_USERS,
    payload: true,
  });
  try {
    const copyOfTenantsBody: IgetTenantsBody = JSON.parse(JSON.stringify(tenantsBody));
    copyOfTenantsBody.index = 0;
    copyOfTenantsBody.limit = 4000;
    copyOfTenantsBody.search = querySearch;

    const getTenantsWithUsersFetch = await getTenantsAPI({
      body: copyOfTenantsBody,
      token,
      signal,
    });
    if (getTenantsWithUsersFetch.response.status === 200) {
      const filteredtenants = getTenantsWithUsersFetch.data
        ?.filter((client) => client?.user_tenants?.length > 0)
        ?.filter((client) =>
          client?.user_tenants?.some(
            (user) => !user.user.username.endsWith('@hub4retail.com')
          )
        );
      dispatch({
        type: SuperAdminTypes.SET_TENANTS_WITH_USERS,
        payload: filteredtenants,
      });
      return true;
    }
    return false;
  } catch (error) {
    console.log(error);
    return false;
  } finally {
    dispatch({
      type: SuperAdminTypes.SET_IS_LOADING_GET_TENANTS_WITH_USERS,
      payload: false,
    });
  }
}

export function removeUserClientAction({
  dispatch,
  tenants,
  tenantId,
  userId,
  translate,
}: {
  dispatch: React.Dispatch<any>;
  tenants: ISAdminTenantState[];
  tenantId: string;
  userId: string;
  translate: ITranslate;
}) {
  const copyOfTenants: ISAdminTenantState[] = JSON.parse(JSON.stringify(tenants));
  const findIndexClient = copyOfTenants.findIndex((client) => client.id === tenantId);
  if (findIndexClient !== -1) {
    const userClients = copyOfTenants[findIndexClient].user_tenants.filter(
      (user) => user.user.id !== userId
    );
    copyOfTenants[findIndexClient].user_tenants = userClients;
    dispatch({
      type: SuperAdminTypes.SET_BRAND_CLIENTS,
      payload: copyOfTenants,
    });
  }
}

export function addUserClientAction({
  dispatch,
  tenants,
  tenantId,
  user,
}: {
  dispatch: React.Dispatch<any>;
  tenants: ISAdminTenantState[];
  tenantId: string;
  user: ITenantUser;
}) {
  const newUser: ISAdminUserTenantState = {
    id: user.key,
    user_id: user.key,
    tenant_id: tenantId,
    createdAt: undefined,
    updatedAt: undefined,
    user: {
      ...user,
      id: user.key,
      i18n_lang_code: 'es',
      sale: '',
      stock: '',
      prediction: '',
      user_notifications: [],
      defaultPassword: true,
    },
  };
  const copyOfTenants: ISAdminTenantState[] = JSON.parse(JSON.stringify(tenants));
  const findIndexClient = copyOfTenants.findIndex((client) => client.id === tenantId);
  if (findIndexClient !== -1) {
    copyOfTenants[findIndexClient].user_tenants.push(newUser);
    dispatch({
      type: SuperAdminTypes.SET_BRAND_CLIENTS,
      payload: copyOfTenants,
    });
  }
}

export async function getConnectorsAction({
  dispatch,
  body,
  token,
  translate,
}: {
  dispatch: React.Dispatch<any>;
  body: TgetConnectorsAPIBodyProps;
  token: string;
  translate: ITranslate;
}) {
  try {
    const getConnectionsFetch = await getConnectionsAPI({ body, token });
    if (getConnectionsFetch.response.status === 200) {
      dispatch({
        type: SuperAdminTypes.SET_CONNECTORS,
        payload: getConnectionsFetch.data,
      });
      return true;
    }
    return false;
  } catch (error) {
    console.log(error);
    return false;
  }
}

// Map fields
export async function getMapFieldsAction({
  dispatch,
  token,
  translate,
}: {
  dispatch: React.Dispatch<any>;
  token: string;
  translate: ITranslate;
}) {
  dispatch({
    type: SuperAdminTypes.IS_LOADING_GET_MAP_FIELDS,
    payload: true,
  });
  try {
    const getMapFieldsFetch = await getMapFieldsAPI({ token });
    if (
      getMapFieldsFetch.response.status === 200 ||
      getMapFieldsFetch.response.status === 201
    ) {
      dispatch({
        type: SuperAdminTypes.GET_MAP_FIELDS,
        payload: getMapFieldsFetch.data.data,
      });
      return true;
    }
    return false;
  } catch (error) {
    messageError('Error del servidor al obtener los campos del mapa');
    notificationErr(superAdminError.get_map_fields_001, translate);
    return false;
  } finally {
    dispatch({
      type: SuperAdminTypes.IS_LOADING_GET_MAP_FIELDS,
      payload: false,
    });
  }
}

export async function createMapFieldAction({
  dispatch,
  fieldData,
  token,
  translate,
}: {
  dispatch: React.Dispatch<any>;
  fieldData:
    | MapFieldReplaceKeyOrValueBodyProps
    | MapFieldSearchBodyProps
    | MapFieldSubstringBodyProps
    | MapFieldPatternBodyProps
    | MapFieldDateBodyProps
    | MapFieldLoopBodyProps
    | MapFieldDeleteBodyProps
    | MapFieldCleanBodyProps;
  token: string;
  translate: ITranslate;
}) {
  dispatch({
    type: SuperAdminTypes.IS_LOADING_CREATE_MAP_FIELD,
    payload: true,
  });
  try {
    const createMapFieldFetch = await createMapFieldAPI({
      mapField: fieldData,
      token,
    });
    if (
      createMapFieldFetch.response.status === 200 ||
      createMapFieldFetch.response.status === 201
    ) {
      messageSuccess('Instrucción creada con éxito');
      dispatch({
        type: SuperAdminTypes.CREATE_MAP_FIELD,
        payload: createMapFieldFetch.data.data[0],
      });
      return true;
    }
    messageError('Error al crear el campo');
    notificationErr(superAdminError.create_map_field_002, translate);
    return false;
  } catch (error) {
    messageError('Error del servidor al crear el campo');
    notificationErr(superAdminError.create_map_field_001, translate);
    return false;
  } finally {
    dispatch({
      type: SuperAdminTypes.IS_LOADING_CREATE_MAP_FIELD,
      payload: false,
    });
  }
}

export async function updateMapFieldAction({
  dispatch,
  body,
  token,
  translate,
}: {
  dispatch: React.Dispatch<any>;
  body: IupdateMapFieldBodyProps;
  token: string;
  translate: ITranslate;
}) {
  dispatch({
    type: SuperAdminTypes.IS_LOADING_UPDATE_MAP_FIELD,
    payload: true,
  });
  try {
    const updateMapFieldFetch = await updateMapFieldAPI({
      body: body,
      token,
    });
    if (
      updateMapFieldFetch.response.status === 200 ||
      updateMapFieldFetch.response.status === 201
    ) {
      messageSuccess('Campo actualizado con éxito');
      dispatch({
        type: SuperAdminTypes.UPDATE_MAP_FIELD,
        payload: {
          id: body.filter.id,
          data: body.update,
        },
      });
      return true;
    }
    messageError('Error al actualizar el campo');
    notificationErr(superAdminError.update_map_field_002, translate);
    return false;
  } catch (error) {
    messageError('Error del servidor al actualizar el campo');
    notificationErr(superAdminError.update_map_field_001, translate);
    return false;
  } finally {
    dispatch({
      type: SuperAdminTypes.IS_LOADING_UPDATE_MAP_FIELD,
      payload: false,
    });
  }
}

export async function deleteMapFieldAction({
  dispatch,
  mapFieldId,
  token,
  translate,
}: {
  dispatch: React.Dispatch<any>;
  mapFieldId: string;
  token: string;
  translate: ITranslate;
}) {
  dispatch({
    type: SuperAdminTypes.IS_LOADING_DELETE_MAP_FIELD,
    payload: {
      mapFieldId,
      loading: true,
    },
  });
  try {
    const deleteMapFieldFetch = await deleteMapFieldAPI({ mapFieldId, token });
    if (deleteMapFieldFetch.response.status === 409) {
      return messageWarning('No se puede eliminar el campo porque está en uso');
    }
    if (
      deleteMapFieldFetch.response.status === 200 ||
      deleteMapFieldFetch.response.status === 201
    ) {
      dispatch({
        type: SuperAdminTypes.DELETE_MAP_FIELD,
        payload: mapFieldId,
      });
      messageSuccess('Campo eliminado con éxito');
      return true;
    }
    messageError('Error al eliminar el campo');
    notificationErr(superAdminError.delete_map_field_002, translate);
    return false;
  } catch (error) {
    messageError('Error del servidor al eliminar el campo');
    notificationErr(superAdminError.delete_map_field_001, translate);
    return false;
  } finally {
    dispatch({
      type: SuperAdminTypes.IS_LOADING_DELETE_MAP_FIELD,
      payload: {
        mapFieldId: '',
        loading: false,
      },
    });
  }
}

// Map fields templates ///////////////////////////////////////////////
export async function getMapFieldsTemplatesAction({
  dispatch,
  token,
  translate,
}: {
  dispatch: React.Dispatch<any>;
  token: string;
  translate: ITranslate;
}) {
  dispatch({
    type: SuperAdminTypes.IS_LOADING_GET_MAP_FIELDS_TEMPLATES,
    payload: true,
  });
  try {
    const getMapFieldsFetch = await getMapFieldsTemplatesAPI({ token });
    if (
      getMapFieldsFetch.response.status === 200 ||
      getMapFieldsFetch.response.status === 201
    ) {
      dispatch({
        type: SuperAdminTypes.GET_MAP_FIELDS_TEMPLATES,
        payload: Object.entries(getMapFieldsFetch.data.data).map(
          ([templateName, rest]) => {
            return {
              templateName,
              mapFields: rest.map((item) => item),
            };
          }
        ),
      });
      return true;
    }
    return false;
  } catch (error) {
    messageError('Error del servidor al obtener los campos del mapa');
    notificationErr(superAdminError.get_map_fields_templates_001, translate);
    return false;
  } finally {
    dispatch({
      type: SuperAdminTypes.IS_LOADING_GET_MAP_FIELDS_TEMPLATES,
      payload: false,
    });
  }
}

export async function createMapFieldsTemplateAction({
  dispatch,
  tag,
  map_field_ids,
  token,
  translate,
}: {
  dispatch: React.Dispatch<any>;
  tag: string;
  map_field_ids: string[];
  token: string;
  translate: ITranslate;
}) {
  dispatch({
    type: SuperAdminTypes.IS_LOADING_CREATE_MAP_FIELDS_TEMPLATE,
    payload: true,
  });
  try {
    const createMapFieldsTemplateFetch = await createMapFieldTemplateAPI({
      tag,
      map_field_ids,
      token,
    });
    if (
      createMapFieldsTemplateFetch.response.status === 200 ||
      createMapFieldsTemplateFetch.response.status === 201
    ) {
      messageSuccess('Plantilla creada con éxito');
      await getMapFieldsTemplatesAction({ dispatch, token, translate });
      return true;
    }
    messageError('Error al crear la plantilla');
    notificationErr(superAdminError.create_map_fields_template_002, translate);
    return false;
  } catch (error) {
    messageError('Error del servidor al crear la plantilla');
    notificationErr(superAdminError.create_map_fields_template_001, translate);
    return false;
  } finally {
    dispatch({
      type: SuperAdminTypes.IS_LOADING_CREATE_MAP_FIELDS_TEMPLATE,
      payload: false,
    });
  }
}

export async function deleteMapFieldTemplateAction({
  dispatch,
  templateName,
  token,
  translate,
}: {
  dispatch: React.Dispatch<any>;
  templateName: string;
  token: string;
  translate: ITranslate;
}) {
  dispatch({
    type: SuperAdminTypes.IS_LOADING_DELETE_MAP_FIELD_TEMPLATE,
    payload: {
      templateName,
      loading: true,
    },
  });
  try {
    const deleteMapFieldTemplateFetch = await deleteMapFieldTemplateAPI({
      templateName,
      token,
    });
    if (deleteMapFieldTemplateFetch.response.status === 409) {
      return messageWarning('No se puede eliminar el campo porque está en uso');
    }
    if (
      deleteMapFieldTemplateFetch.response.status === 200 ||
      deleteMapFieldTemplateFetch.response.status === 201
    ) {
      dispatch({
        type: SuperAdminTypes.DELETE_MAP_FIELD_TEMPLATE,
        payload: templateName,
      });
      messageSuccess('Plantilla eliminada con éxito');
      return true;
    }
    messageError('Error al eliminar la plantilla');
    notificationErr(superAdminError.delete_map_field_template_002, translate);
    return false;
  } catch (error) {
    messageError('Error del servidor al eliminar la plantilla');
    notificationErr(superAdminError.delete_map_field_template_001, translate);
    return false;
  } finally {
    dispatch({
      type: SuperAdminTypes.IS_LOADING_DELETE_MAP_FIELD_TEMPLATE,
      payload: {
        templateName: '',
        loading: false,
      },
    });
  }
}

// Queries Shopify
export async function getShopifyQueriesAction(
  dispatch: React.Dispatch<any>,
  token: string,
  translate: ITranslate
) {
  dispatch({ type: SuperAdminTypes.SET_IS_LOADING_QUERIES, payload: true });
  try {
    const getQueriesFetch = await getShopifyQueriesAPI({ token });
    if (getQueriesFetch.response.status === 200) {
      dispatch({
        type: SuperAdminTypes.SET_QUERIES,
        payload: getQueriesFetch.data.data,
      });
      return true;
    }
    return false;
  } catch (error) {
    messageError(translate('action_meta_get-queries_error'));
    notificationErr(superAdminError.get_shopify_queries_001, translate);
    return false;
  } finally {
    dispatch({ type: SuperAdminTypes.SET_IS_LOADING_QUERIES, payload: false });
  }
}

export async function selectShopifyQueryAction(
  dispatch: React.Dispatch<any>,
  query: IShopifyQueryItem
) {
  dispatch({
    type: SuperAdminTypes.SET_QUERY_SELECTED,
    payload: query,
  });
}

type TcreateQueryActionProps = {
  dispatch: React.Dispatch<any>;
  values: ICreateQueryProps;
  token: string;
  translate: ITranslate;
};
export async function createShopifyQueryAction({
  dispatch,
  values,
  token,
  translate,
}: TcreateQueryActionProps) {
  dispatch({ type: SuperAdminTypes.SET_IS_LOADING_CREATE_QUERY, payload: true });
  if (!values.scope || values.scope === '' || values.scope === undefined) {
    delete values.scope;
  }
  if (!values.audience || values.audience === undefined) {
    delete values.audience;
  }
  try {
    const createQueryFetch = await createShopifyQueryAPI({
      body: values,
      token,
    });
    if (createQueryFetch.response.status === 409) {
      messageWarning('Ya existe una query con ese nombre, por favor elige otro');
      return false;
    }
    if (
      createQueryFetch.response.status === 200 ||
      createQueryFetch.response.status === 201
    ) {
      messageSuccess('Query creada con éxito');
      dispatch({
        type: SuperAdminTypes.ADD_NEW_QUERY,
        payload: createQueryFetch.data,
      });
      return true;
    }
    messageError('Error al crear la query');
    notificationErr(superAdminError.create_shopify_query_002, translate);
    return false;
  } catch (error) {
    messageError('Error del servidor al crear la query');
    notificationErr(superAdminError.create_shopify_query_001, translate);
    return false;
  } finally {
    dispatch({ type: SuperAdminTypes.SET_IS_LOADING_CREATE_QUERY, payload: false });
  }
}

export async function deleteShopifyQueryAction({
  dispatch,
  queryId,
  token,
  translate,
}: {
  dispatch: React.Dispatch<any>;
  queryId: string;
  token: string;
  translate: ITranslate;
}) {
  dispatch({
    type: SuperAdminTypes.SET_IS_LOADING_DELETE_QUERY,
    payload: { loading: true, queryId },
  });
  try {
    const deleteQueryFetch = await deleteShopifyQueryAPI({
      queryId,
      token,
    });
    if (deleteQueryFetch.response.status === 200) {
      messageSuccess('Query eliminada con éxito');
      dispatch({
        type: SuperAdminTypes.DELETE_QUERY,
        payload: queryId,
      });
      return true;
    }
    messageError('Error al eliminar la query');
    notificationErr(superAdminError.delete_shopify_query_002, translate);
    return false;
  } catch (error) {
    messageError('Error del servidor al eliminar la query');
    notificationErr(superAdminError.delete_shopify_query_001, translate);
    return false;
  } finally {
    dispatch({
      type: SuperAdminTypes.SET_IS_LOADING_DELETE_QUERY,
      payload: { loading: false, queryId: '' },
    });
  }
}

export async function updateShopifyQueryAction({
  dispatch,
  dataToUpdate,
  showSuccessMsg = true,
  token,
  translate,
}: {
  dispatch: React.Dispatch<any>;
  dataToUpdate: IUpdateQueryProps;
  showSuccessMsg?: boolean;
  token: string;
  translate: ITranslate;
}) {
  dispatch({ type: SuperAdminTypes.SET_IS_LOADING_UPDATE_QUERY, payload: true });
  if (
    !dataToUpdate.scope ||
    dataToUpdate.scope === '' ||
    dataToUpdate.scope === undefined
  ) {
    delete dataToUpdate.scope;
  }
  if (!dataToUpdate.audience || dataToUpdate.audience === undefined) {
    delete dataToUpdate.audience;
  }
  try {
    const updateQueryFetch = await updateShopifyQueryAPI({
      dataToUpdate,
      token,
    });
    if (updateQueryFetch.response.status === 200) {
      showSuccessMsg &&
        showSuccessMsg === true &&
        messageSuccess('Query actualizada con éxito');
      dispatch({
        type: SuperAdminTypes.UPDATE_QUERY,
        payload: {
          id: dataToUpdate.queryId,
          data: {
            tag: dataToUpdate.tag,
            description: dataToUpdate.description,
            query: dataToUpdate.query,
            indexable: dataToUpdate.indexable,
            scope: dataToUpdate.scope,
          },
        },
      });
      return true;
    }
    messageError('Error al actualizar la query');
    notificationErr(superAdminError.update_shopify_query_002, translate);
    return false;
  } catch (error) {
    messageError('Error del servidor al actualizar la query');
    notificationErr(superAdminError.update_shopify_query_001, translate);
    return false;
  } finally {
    dispatch({ type: SuperAdminTypes.SET_IS_LOADING_UPDATE_QUERY, payload: false });
  }
}

// Templates shopify
export async function getShopifyTemplatesAction({
  dispatch,
  token,
  translate,
}: {
  dispatch: React.Dispatch<any>;
  token: string;
  translate: ITranslate;
}) {
  dispatch({ type: SuperAdminTypes.SET_IS_LOADING_TEMPLATES, payload: true });
  try {
    const getTemplatesFetch = await getTemplatesAPI({ token });
    if (getTemplatesFetch.response.status === 200) {
      const formattedData: IShopifyTemplateItem[] = Object.keys(
        getTemplatesFetch.data.data
      ).map((key) => {
        return {
          tag: key,
          queries: getTemplatesFetch.data.data[key].map(
            (item: { id: string }) => item.id
          ),
        };
      });
      dispatch({
        type: SuperAdminTypes.SET_TEMPLATES,
        payload: formattedData,
      });
      return true;
    }
    return false;
  } catch (error) {
    messageError('Error del servidor al obtener las plantillas');
    notificationErr(superAdminError.get_shopify_templates_001, translate);
    return false;
  } finally {
    dispatch({ type: SuperAdminTypes.SET_IS_LOADING_TEMPLATES, payload: false });
  }
}

export function selectShopifyTemplateAction({
  dispatch,
  template,
}: {
  dispatch: React.Dispatch<any>;
  template: IShopifyTemplateItem;
}) {
  dispatch({
    type: SuperAdminTypes.SET_TEMPLATE_SELECTED,
    payload: template,
  });
}

export async function createUpdateShopifyTemplateAction({
  dispatch,
  values,
  token,
  translate,
}: {
  dispatch: React.Dispatch<any>;
  values: IShopifyTemplateItem;
  token: string;
  translate: ITranslate;
}) {
  dispatch({
    type: SuperAdminTypes.SET_IS_LOADING_CREATE_UPDATE_TEMPLATE,
    payload: true,
  });
  try {
    const createUpdateTemplateFetch = await createShopifyTemplateAPI({
      body: values,
      token,
    });
    if (createUpdateTemplateFetch.response.status === 409) {
      messageWarning('Ya existe una plantilla con ese nombre, por favor elige otro');
      return false;
    }
    if (
      createUpdateTemplateFetch.response.status === 200 ||
      createUpdateTemplateFetch.response.status === 201
    ) {
      messageSuccess('Plantilla creada con éxito');
      dispatch({
        type: SuperAdminTypes.CREATE_UPDATE_TEMPLATE,
        payload: {
          tag: values.tag,
          data: values,
        },
      });
      return true;
    }
    messageError('Error al crear la plantilla');
    notificationErr(superAdminError.create_update_shopify_template_002, translate);
    return false;
  } catch (error) {
    messageError('Error del servidor al crear la plantilla');
    notificationErr(superAdminError.create_update_shopify_template_001, translate);
    return false;
  } finally {
    dispatch({
      type: SuperAdminTypes.SET_IS_LOADING_CREATE_UPDATE_TEMPLATE,
      payload: false,
    });
  }
}

export async function deleteShopifyTemplateAction({
  dispatch,
  templateTag,
  token,
  translate,
}: {
  dispatch: React.Dispatch<any>;
  templateTag: string;
  token: string;
  translate: ITranslate;
}) {
  dispatch({
    type: SuperAdminTypes.SET_IS_LOADING_DELETE_TEMPLATE,
    payload: { loading: true, tag: templateTag },
  });
  try {
    const deleteTemplateFetch = await deleteShopifyTemplateAPI({
      templateTag,
      token,
    });
    if (deleteTemplateFetch.response.status === 200) {
      messageSuccess('Plantilla eliminada con éxito');
      dispatch({
        type: SuperAdminTypes.DELETE_TEMPLATE,
        payload: templateTag,
      });
      return true;
    }
    messageError('Error al eliminar la plantilla');
    notificationErr(superAdminError.delete_shopify_template_002, translate);
    return false;
  } catch (error) {
    messageError('Error del servidor al eliminar la plantilla');
    notificationErr(superAdminError.delete_shopify_template_001, translate);
    return false;
  } finally {
    dispatch({
      type: SuperAdminTypes.SET_IS_LOADING_DELETE_TEMPLATE,
      payload: { loading: false, tag: '' },
    });
  }
}
